export default __webpack_public_path__ + "a1cfc3dfcc68c69ba47f56c999b6ffb9.png";